import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getGroup(id) {
        return axios.get(config.publicPath + 'pmta_relay_groups/' + id, {
            headers: JsonHeaders
        });
    },
    getGroups(currentPage, perPage, user_id, name) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            "user.id": user_id,
            name: name
        };
        return axios.get(config.publicPath + 'pmta_relay_groups', {
            params: parameters,
            headers: JsonHeaders
        });
    },
    getGroupSelect(user_id = null) {
        return axios.get(config.publicPath + 'pmta_relay_groups', {
            params: {'groups[]': 'select', 'user.id': user_id, 'pagination': false},
            headers: JsonHeaders
        });
    },
    createGroup(data) {
        return axios.post(config.publicPath + 'pmta_relay_groups', data, {
            headers: JsonHeaders
        });
    },
    updateGroup(id, data) {
        return axios.put(config.publicPath + 'pmta_relay_groups/' + id, data, {
            headers: JsonHeaders
        });
    },
    deleteGroup(id) {
        let data = {
            type: 'pmta',
            id: id,
        };
        return axios.post(config.publicPath + 'relay_group/delete', JSON.stringify(data), {
            headers: JsonHeaders
        });
    }
}